import Vue from 'vue'
import { GET_SOCIAL_STATUSES } from '../mutation-types.js'

export const getSocialStatuses = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('social_status')
    .then(
      (response) => {
        dispatch(GET_SOCIAL_STATUSES, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/socialStatusesActions.js